/**
 * CSV import — `docs/API.md` §15, `salescrmapi/src/modules/imports`. Only
 * `entity_key: 'lead'` is implemented. The CSV itself goes through the
 * existing `files.api.js` presigned upload/commit pair, not a route here —
 * `source_object_id` in `createImport`'s body is that upload's `object_id`.
 */
import apiClient from './axiosClient.js';
import { withMockFallback } from './mockFallback.js';

/** @param {{entity_key:'lead', source_object_id:string, duplicate_strategy?:string}} body */
export function createImport(body) {
  return withMockFallback(
    'POST /imports',
    async () => (await apiClient.post('/imports', body, {
      headers: { 'Idempotency-Key': crypto.randomUUID() },
    })).data,
    () => { throw new Error('CSV import is not available in this build.'); },
  );
}

/** @param {string} id */
export function getImport(id) {
  return withMockFallback(
    `GET /imports/${id}`,
    async () => (await apiClient.get(`/imports/${id}`)).data,
    () => null,
  );
}

/** @param {string} id @param {{field_mapping?:Record<string,string>}} [body] */
export function validateImport(id, body = {}) {
  return withMockFallback(
    `POST /imports/${id}/validate`,
    async () => (await apiClient.post(`/imports/${id}/validate`, body)).data,
    () => { throw new Error('CSV import is not available in this build.'); },
  );
}

/** @param {string} id @param {{field_mapping?:Record<string,string>, duplicate_strategy?:string}} [body] */
export function executeImport(id, body = {}) {
  return withMockFallback(
    `POST /imports/${id}/execute`,
    async () => (await apiClient.post(`/imports/${id}/execute`, body, {
      headers: { 'Idempotency-Key': crypto.randomUUID() },
    })).data,
    () => { throw new Error('CSV import is not available in this build.'); },
  );
}
